import { render, staticRenderFns } from "./LicenceDetailItem.vue?vue&type=template&id=2b460808&scoped=true"
import script from "./LicenceDetailItem.vue?vue&type=script&lang=js"
export * from "./LicenceDetailItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b460808",
  null
  
)

export default component.exports